import { OverlayTrigger, Tooltip } from "react-bootstrap";

const BftInfoTooltip = ({
	message,
	className,
	onClick,
}: {
	message?: any;
	className?: string;
	onClick?: () => void;
}) => {
	return (
		<>
			<OverlayTrigger
				key={message}
				overlay={<Tooltip id={`tooltip-${message}`}>{message}</Tooltip>}
			>
				<div className={`info-tooltip ${className}`} onClick={onClick}>
					<i
						className="fa-solid fa-info"
						style={{ fontSize: "0.7rem", paddingBottom: "0.1rem" }}
					></i>
				</div>
			</OverlayTrigger>
		</>
	);
};

export default BftInfoTooltip;
